/**
 * @date 2018-10-31
 * @file all api from wx-sdk@1.4
 */
export const JS_API_LIST = [
  'onMenuShareAppMessage',
  'onMenuShareTimeline',
  'onMenuShareQQ',
  'onMenuShareWeibo',
  'onMenuShareQZone',
  'previewImage',
  'getLocation',
  'openProductSpecificView',
  'addCard',
  'openCard',
  'chooseCard',
  'openProductSpecificView',
  'scanQRCode',
  'chooseWXPay',
  'openEnterpriseRedPacket',
  'startSearchBeacons',
  'stopSearchBeacons',
  'onSearchBeacons',
  'consumeAndShareCard',
  'openAddress',
  'updateAppMessageShareData',
  'updateTimelineShareData',
  'chooseImage',
  'uploadImage',
  'downloadImage',
  'getLocalImgData',
  'startRecord',
  'stopRecord',
  'onVoiceRecordEnd',
  'playVoice',
  'pauseVoice',
  'stopVoice',
  'onVoicePlayEnd',
  'uploadVoice',
  'translateVoice',
  'getNetworkType',
  'openLocation',
  'getLocation',
  'startSearchBeacons',
  'stopSearchBeacons',
  'onSearchBeacons',
  'closeWindow',
  'hideMenuItems',
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem'
]